import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Markteintritt";
const heroImage = "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp";
const heroAlt = "Hand markiert ein rotes Zielsegment in überlappenden Kreisen für die Markteintrittsstrategie.";
const heroClaimLine1 = "Kurs auf";
const heroClaimLine2 = "Ihren Marktanteil!";
const benefitsTitle = "Wie Sie von unserer Expertise im Bereich __Markteintritt__ profitieren:";
const introText = "Strategischer Markteintritt für Ihren nachhaltigen Erfolg im DACH-Markt. Als Ihre erfahrene lokale Ressource unterstützen wir ausländische ITK-Hersteller bei der Identifizierung, Entwicklung und Konzeption optimaler Eintrittsoptionen in den deutschsprachigen Wirtschaftsraum.";
const p1Text = "NetBasis International ist seinen Partnern die lokale Ressource für die Identifizierung, Entwicklung und Konzeption von Eintrittsoptionen in neue Märkte. Durch gezielte Marktforschung und fundierte Markteinblicke begleiten wir den gesamten Planungsprozess unserer Herstellerpartner, helfen bei strategischen Schlüsselentscheidungen und erzielen die bestmögliche Marktpräsenz vor Ort.";
const p1Parts = p1Text.split(COMPANY_NAME);
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Durchführung von detaillierten Markteinschätzungen und fundierten Bewertungen der Zielmärkte",
  "Generelle Entscheidungshilfe und Beratung, in welche regionalen Teilmärkte investiert werden sollte",
  "Umfassende Unterstützung bei der Planung und Ausführung auf Basis lokaler Marktbeobachtung",
  "Gründliche Analyse potenzieller Konkurrenten sowie Ermittlung relevanter Zielkunden",
  "Direkter Zugriff auf unsere etablierten Vertriebsnetze zur schnellen Generierung von Marktanteilen",
  "Sicherstellung aller notwendigen kaufmännischen Kompetenzen für ein erfolgreiches Markteintritts-Projekt",
];

export default function MarkteintrittDePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Markteintritt | NetBasis International"
        description="Maßgeschneiderte Konzepte und strategische Fahrpläne für den sicheren und effizienten Start Ihres Unternehmens in der DACH-Region."
        ogUrl="https://net-basis.net/de/services/business-development/markteintritt"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[14%] md:pt-[10%] lg:pt-[9%] pointer-events-none">
                <p
                  className="mes-hero-lh-15 markteintritt-hero-text-slide text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:hidden">{heroClaimLine1}</span>
                  <span className="block md:hidden">{heroClaimLine2}</span>
                  <span className="hidden md:block">{heroClaimLine1} {heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {introText}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Green heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Benefits with green checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}